/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
// @ts-nocheck
/* eslint-disable import/no-unresolved */
/* eslint-disable import/order */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Grid from '@material-ui/core/Grid';

// Project
import { selectState, actionProps } from 'utils/reduxActions';
import { homeActions } from 'screens/Home/reducer';
import { ReactReduxContext } from 'config/configureStore';
import connectSaga from 'utils/saga';
import saga from './saga';

import { clone, truthty, falsy } from 'utils/functions';
import { Container, withStyles } from '@material-ui/core';
import { varietiesActions } from 'screens/Varieties/reducer';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CardHeader from '@material-ui/core/CardHeader';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
// styles
import styles from './styles';
import VarietyForm from './components/VarietyForm';
import DeleteModal from 'commons/components/DeleteModal';
import MaintainersPaginator from 'commons/components/MaintainersPaginator';
import TableActionMenu from 'commons/components/TableActionMenu';

const useStyles = makeStyles(styles);

function Varieties(props) {
  const {
    objects,
    actions,
    formIsOpen,
    formControls,
    edit,
    invalidControls,
    deleteIsOpen,
    toEditId,
    toDeleteId,
  } = props;
  const [varietyList, setVarietyList] = useState([]);
  const [filter, setFilter] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    setVarietyList(
      Object.values(objects.varieties)
        .filter((item) => item.name.toLowerCase().includes(filter.toLowerCase()))
        .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())),
    );
  }, [objects.varieties, filter]);

  useEffect(() => {
    actions.getStateFromApi();
  }, [actions]);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function toggleForm() {
    actions.toggleForm('formIsOpen');
  }

  function closeForm() {
    actions.toggleForm('deleteIsOpen');
  }

  function toggleDelete() {
    handleClose();
    actions.toggleDelete(anchorEl.dataset.id);
  }

  function toggleEdit() {
    handleClose();
    const item = Object.values(objects.varieties).find(
      (item) => item.id === Number(anchorEl.dataset.id),
    );
    actions.toggleEdit(item);
  }

  function changeControls(event) {
    if (event.autocomplete) {
      actions.changeControls({ [event.input]: event.value }, { [event.input]: false });
    } else {
      actions.changeControls(
        { [event.currentTarget.id]: event.target.value },
        { [event.currentTarget.id]: false },
      );
    }
  }

  function submit() {
    if (falsy(formControls.name) || falsy(formControls.fruitId)) {
      actions.setInvalidControls({
        name: falsy(formControls.name),
        fruitId: falsy(formControls.fruitId),
      });
    } else if (edit) {
      actions.editVariety(toEditId, formControls);
    } else {
      actions.createVariety(formControls);
    }
  }

  function submitDelete() {
    actions.deleteVariety(toDeleteId);
  }

  function onFilterChange(event) {
    setFilter(event.target.value);
  }

  const classes = useStyles();

  const getListItem = (variety, openMenuHandler, closeMenuHandler, toggleEdit, toggleDelete) => (
    <ListItem key={`variety-${variety.id}`}>
      <ListItemAvatar>
        <Avatar className={classes.blue}>{(variety.name || 'p')[0].toUpperCase()}</Avatar>
      </ListItemAvatar>
      <ListItemText primary={variety.name} />
      <ListItemSecondaryAction>
        <IconButton onClick={openMenuHandler} data-id={variety.id}>
          <MoreVertIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );

  return (
    <Container maxWidth={false}>
      <Grid container spacing={3} className={classes.container}>
        <Grid item xs={12}>
          <Typography variant="h3" component="h2" className={classes.marginTop}>
            {t('Varieties')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Card className={classes.root}>
            <CardHeader title={t('Filter')} />
            <CardContent>
              <Grid container spacing={3} className={classes.container}>
                <Grid container item xs={4}>
                  <TextField
                    fullWidth
                    id="standard-basic"
                    label={t('Name')}
                    value={filter}
                    onChange={onFilterChange}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid container item>
          <Grid item xs={12} sm={4} md={3}>
            <TableActionMenu
              menuItems={[
                {
                  label: t('Export'),
                  listItems: [
                    {
                      label: t('Excel file'),
                      onClick: actions.exportVarieties,
                      params: [Object.values(objects.varieties)],
                    },
                  ],
                },
              ]}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Card className={classes.root}>
            <CardContent>
              {truthty(objects.varieties) ? (
                <MaintainersPaginator
                  classes={classes}
                  list={varietyList}
                  getListItem={getListItem}
                  openMenuHandler={handleClick}
                  closeMenuHandler={handleClose}
                  toggleEdit={toggleEdit}
                  toggleDelete={toggleDelete}
                />
              ) : (
                <Grid container item xs={12} alignItems="center" justifyContent="center">
                  <Typography variant="h6" component="h2">
                    {t('No varieties')}
                  </Typography>
                </Grid>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <VarietyForm
        isOpen={formIsOpen}
        toggleForm={toggleForm}
        changeControls={changeControls}
        controls={formControls}
        fruits={objects.fruits}
        edit={edit}
        submit={submit}
        invalidControls={invalidControls}
      />
      <DeleteModal
        isOpen={deleteIsOpen}
        toggleForm={closeForm}
        submit={submitDelete}
        buttonId="delete-variety"
      />
      <Fab color="primary" aria-label="add" className={classes.fab} onClick={toggleForm}>
        <AddIcon />
      </Fab>
      <Menu anchorEl={anchorEl} keepMounted open={truthty(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={toggleEdit}>
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          {t('Edit')}
        </MenuItem>
        <MenuItem onClick={toggleDelete}>
          <ListItemIcon>
            <DeleteIcon />
          </ListItemIcon>
          {t('Delete')}
        </MenuItem>
      </Menu>
    </Container>
  );
}

const withSaga = connectSaga({ key: 'sagaVarieties', saga });

const withConnect = connect(
  selectState(
    'varieties.invalidControls',
    'varieties.formControls',
    'varieties.deleteIsOpen',
    'varieties.toDeleteId',
    'varieties.formIsOpen',
    'varieties.toEditId',
    'varieties.edit',
    'app.objects',
  ),
  actionProps(clone(clone.OBJECT, homeActions, varietiesActions)),
  null,
  { context: ReactReduxContext },
);

export default compose(withStyles(styles), withRouter, withConnect)(withSaga(Varieties));
